import {
  useApiError,
  withApiError,
} from "@raiden/library/components/ReactHookForm/ApiError";
import { CUSTOMERS_TYPES_VALUE_PARTICULAR } from "@raiden/library/constants/customers";
import { usePreferences } from "@raiden/library/contexts/Preferences";
import useAuthAs from "@raiden/library/hooks/auth/as";
import useRequest from "@raiden/library/hooks/useRequest";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import Form from "./Form";

const SignUpHandler = withApiError(
  /**
   * @typedef {object} Props
   * @property {import("@raiden/library/types/Countries/Country").Country[]} countries
   *
   * @param {Props} props
   */
  function SignUpHandler({ countries }) {
    const intl = useIntl();

    const { request, isLoading, toastSuccess } = useRequest();

    const { bestEnvironment } = usePreferences();

    const { resolveApiError, resetApiErrors } = useApiError();

    const { mutate } = useAuthAs();

    const form = useForm({
      defaultValues: {
        data: {
          environment_id: bestEnvironment?.id,
          type: CUSTOMERS_TYPES_VALUE_PARTICULAR,
          first_name: "",
          last_name: "",
          birthdate: "",
          composition: "",
          address_1: "",
          address_2: "",
          zipcode: "",
          city: "",
          country_id:
            countries.find((country) => country.iso_code === "FR")?.id ?? "",
          phone_country: "FR",
          phone_number: "",
          email: "",
          caf_coeff: "",
          caf_number: "",
          dependent_children_count: "",
          reference_tax_income: "",
          password: "",
        },
        _password_confirmation: "",
      },
    });
    const { handleSubmit, reset } = form;

    function onSubmit(fields) {
      request(generateApiUri({ id: "@customers.create" }), {
        method: "POST",
        body: {
          data: fields.data,
          meta: {
            auto_connect: true,
            create_associated_holder: true,
          },
        },
      })
        .then(() => {
          reset();
          resetApiErrors();
          toastSuccess({
            title: intl.formatMessage({
              defaultMessage: "Inscription réussie",
            }),
          });
          mutate();
        })
        .catch((response) => {
          resolveApiError({ form, response });
        });
    }

    return (
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Form isLoading={isLoading} />
        </form>
      </FormProvider>
    );
  },
);

export default SignUpHandler;
